<template>
  <h3 class="pb5">Enquêtes en retard (CDX 0247)</h3>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>

import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "EnqueteEnRetard",
  components: {ButtonBar},
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      criteresRapportVO: {},
    };
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Habilitation sécuritaire");
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      this.criteresRapportVO.titre = "EnqueteEnRetard";
      this.criteresRapportVO.nomRapport = "dossier.EnqueteEnRetardGenerateurRapport_CDX_0247";
      this.$store.dispatch("rapports/obtenirRapportAction",
          this.criteresRapportVO
      )
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>